import { Injectable } from '@angular/core';
import { FormField } from '../model/form-field.model';
import { FormFieldSearch } from '../model/form-field-search.model';
import { IFormFields } from './iform-fields.service';
import { ApiService, ApiCacheOptions, PagedSearch, PagedResult } from '../../../shared/index'; //app/shared/index barrel;
import { FormFieldGroup } from '../model/form-field-group.model';
import { FieldGroupTypeEnum } from '../model/field-group-type-enum.model';
import { FormElementSocialMediaType } from '../model/social-media/form-element-social-media-type.model';
import { NameDescrVal } from '../../../shared/model/name-descr-val.model';

@Injectable()
export class FormFields implements IFormFields {
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public getFormFieldGroups = (): Promise<Array<FormFieldGroup>> => {
    let url: string = '/Forms/JoinForm/Fields/Groups';
    return this._apiService.get(url, this._cacheOptions);
  };

  public getFormFieldsForGroup = (fieldGroupType: number): Promise<Array<FormField>> => {
    let url: string = '/Forms/JoinForm/FieldGroup/' + fieldGroupType.toString() + '/Fields';
    return this._apiService.get(url, this._cacheOptions);
  };

  public getFieldGroupTypeEnumName = (groupTypeEnumValue: FieldGroupTypeEnum): string => {
    switch (groupTypeEnumValue) {
      case FieldGroupTypeEnum.AdditionalInfoFields:
        return 'Additional Info';
      case FieldGroupTypeEnum.MembershipFields:
        return 'Membership';

      case FieldGroupTypeEnum.None:
        return 'None';

      case FieldGroupTypeEnum.ProfileFields:
        return 'Profile';

      case FieldGroupTypeEnum.PurchaseItemFields:
        return 'Purchase Item';

      case FieldGroupTypeEnum.RelatedProfileFields:
        return 'Related Profile';
      case FieldGroupTypeEnum.SocialMedia:
        return 'Social Media';
      case FieldGroupTypeEnum.Listing:
        return 'Listing Information';
      default:
        return '';
    }
  };

  public getActiveSocialMediaTypes = (): Promise<any> => {
    let url: string = '/Profiles/SocialMediaTypes?Active=true';
    return this._apiService.get(url, this._cacheOptions);
  };

  getFormFieldAvailableValues(fieldType: number): Promise<Array<NameDescrVal>> {
    let url: string = '/Forms/JoinForm/Fields/' + fieldType.toString() + '/AvailableValues';
    return this._apiService.get(url, this._cacheOptions);
  }
}
